import { SB } from '@play-co/replicant';

export const chatbotSchema = {
  chatbot: SB.object({
    group: SB.string().optional(),
    resubscriptionPromptTimestamp: SB.number().optional(),
    resubscriptionState: SB.string().optional(),
    /** All-time count of legacy resubscribe popup views (prompt / force / direct_overlay). */
    resubscribePopupViewCount: SB.int().default(0),
    /** All-time count of OA Add-Friend overlay views (SC onboarding). */
    addFriendPopupViewCount: SB.int().default(0),
    /** All-time count of profile-consent popover views (SC onboarding). */
    profileConsentPopupViewCount: SB.int().default(0),

    // Status message ramp tracking for new installs A/B test
    statusMessageRamp: SB.object({
      jstDay: SB.int(), // JST day number (for day change detection)
      totalCount: SB.int().default(0), // Total status messages sent today
      limitedTypeCounts: SB.map(SB.int()), // Per-type counts for limited statuses (daily)
      halfDayNumber: SB.int(), // Half-day period identifier for period change detection
      halfDayLimitedCount: SB.int().default(0), // Limited messages sent in current half-day period
    }).optional(),
  }),
};
